// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1scil","badges":"styles_badges__ydXb_"};